import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
    Card,
    CardBody,
    CardHeader,
} from 'reactstrap'

import DevicesGoogleMap from './DevicesGoogleMap'
import { readDevices } from '../devices/helpers'

const DevicesMap = () => {
    const { t } = useTranslation()

    useEffect(() => {
        readDevices()
    }, [])

    return (
        <Card className="mt-3 mt-lg-0">
            <CardHeader className="bg-light d-flex justify-content-between">
                <h5 className="mb-0">{t('device.devices')}</h5>
            </CardHeader>
            <CardBody className="p-0 overflow-hidden">
                <DevicesGoogleMap />
            </CardBody>
        </Card>
    )
}

export default DevicesMap
